<template>
  <Dialog
    :visible="visible"
    modal
    :closable="false"
    :show-header="false"
    :style="{ width: '420px' }"
    @update:visible="$emit('update:visible', $event)"
  >
    <section class="text-center py-4">
      <div
        class="w-14 h-14 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center mx-auto mb-4"
      >
        <span class="material-symbols-rounded text-3xl">shield</span>
      </div>
      <h3 class="text-lg font-semibold text-gray-900 mb-2">
        {{ t('ui.mfa.recommended.dialogTitle') }}
      </h3>
      <p class="text-sm text-gray-600 leading-relaxed max-w-xs mx-auto">
        {{ t('ui.mfa.recommended.dialogBody') }}
      </p>
    </section>

    <template #footer>
      <div class="flex flex-col gap-2 w-full">
        <Button
          :label="t('ui.mfa.recommended.dialogSetup')"
          class="w-full"
          @click="$emit('setup')"
        />
        <Button
          :label="t('ui.mfa.recommended.dialogLater')"
          text
          severity="secondary"
          class="w-full"
          @click="$emit('dismiss')"
        />
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{ visible: boolean }>();
defineEmits<{
  'update:visible': [value: boolean];
  setup: [];
  dismiss: [];
}>();
</script>
